import moment, { Moment } from 'moment';

export interface IOrderInvoice {
  id: number;
  order_id: number;
  is_active: number;
  is_paid: number;
  is_cancelled: number;
  price: string;
  interest_rate: string;
  penalty_rate: string;
  price_paid: string;
  interest_amount: string;
  penalty_amount: string;
  data_emissao: Moment;
  data_vencimento: Moment;
  numero: string;
  numero_carteira: number;
  numero_variacao_carteira: number;
  codigo_cliente: number;
  linha_digitavel: string;
  codigo_barra_numerico: string;
  numero_contrato_cobranca: number;
  qr_code_url: string;
  qr_code_txId: string;
  qr_code_emv: string;
  complete_at: Moment;
  created_at: Moment;
  updated_at: Moment;
  deleted_at: Moment;
}

export class OrderInvoice {
  id: number;
  order_id: number;
  is_active: number;
  is_paid: number;
  is_cancelled: number;
  price: string;
  interest_rate: string;
  penalty_rate: string;
  price_paid: string;
  interest_amount: string;
  penalty_amount: string;
  data_emissao: Moment;
  data_vencimento: Moment;
  numero: string;
  numero_carteira: number;
  numero_variacao_carteira: number;
  codigo_cliente: number;
  linha_digitavel: string;
  codigo_barra_numerico: string;
  numero_contrato_cobranca: number;
  qr_code_url: string;
  qr_code_txId: string;
  qr_code_emv: string;
  complete_at: Moment;
  created_at: Moment;
  updated_at: Moment;
  deleted_at: Moment;

  constructor(data: IOrderInvoice) {
    this.id = data.id;
    this.order_id = data.order_id;
    this.is_active = data.is_active;
    this.is_paid = data.is_paid;
    this.is_cancelled = data.is_cancelled;
    this.price = data.price;
    this.interest_rate = data.interest_rate;
    this.penalty_rate = data.penalty_rate;
    this.price_paid = data.price_paid;
    this.interest_amount = data.interest_amount;
    this.penalty_amount = data.penalty_amount;
    this.data_emissao = moment(data.data_emissao);
    this.data_vencimento = moment(data.data_vencimento);
    this.numero = data.numero;
    this.numero_carteira = data.numero_carteira;
    this.numero_variacao_carteira = data.numero_variacao_carteira;
    this.codigo_cliente = data.codigo_cliente;
    this.linha_digitavel = data.linha_digitavel;
    this.codigo_barra_numerico = data.codigo_barra_numerico;
    this.numero_contrato_cobranca = data.numero_contrato_cobranca;
    this.qr_code_url = data.qr_code_url;
    this.qr_code_txId = data.qr_code_txId;
    this.qr_code_emv = data.qr_code_emv;
    this.complete_at = moment(data.complete_at);
    this.created_at = moment(data.created_at);
    this.updated_at = moment(data.updated_at);
    this.deleted_at = moment(data.deleted_at);
  }
}
